import mali from "../Assets/svg/menu/Invoice_nv.svg";
import tolid from "../Assets/svg/menu/Manufacturing_nv.svg";
import tarahi from "../Assets/svg/menu/Designing_nv.svg";
import shop from "../Assets/svg/menu/diagram-3.svg";

export const SettingsMenuItems = [
  {
    id: 4,
    menu_title: "tanzimatShop",
    menu_icon: shop,
    path: "/dashboard/settings/shop",
  },
  {
    id: 3,
    menu_title: "tanzimatTarahi",
    menu_icon: tarahi,
    path: "/dashboard/settings/design",
  },
  {
    id: 2,
    menu_title: "tanzimatGozareshatTolide",
    menu_icon: tolid,
    path: "/dashboard/settings/construction",
  },
  {
    id: 1,
    menu_title: "tanzimatGozareshatMali",
    menu_icon: mali,
    path: "/dashboard/settings/invoice",
  },
];
